const AuthInitVal = {
  candidateID: "",
  personalEmail: "",
  firstName: "",
  middleName: "",
  lastName: "",
  currentTitle: "",
  currentCompany: "",
  primaryPhone: "",
  secondaryPhone: "",
  preferedContactMethodID: "",
  homeAddress1: "",
  homeAddress2: "",
  homeAddress3: "",
  city: "",
  province: "",
  stateID: "",
  zipCode: "",
  countryID: "",
  countryName: "",

  highestLevelOfEducationID: "",

  candidateCoverLetterUniqueID: "",
  candidateResumeUniqueID: "",
  candidateCoverLetterFileFriendlyName: "",
  candidateResumeFileFriendlyName: "",


  candidateBirthCertificateUniqueID: "",
  candidateBirtCertificateFriendlyName: "",
  candidateCXCUniqueID: "",
  candidateCXCFriendlyName: "",
  candidateCOCUniqueID: "",
  candidateCOCFileFriendlyName: "",

  candidateNationalIDFileFriendlyName: "",
  candidateNationalIDUniqueID: "",
  candidateHSDiplomaFileFriendlyName: "",
  candidateHSDiplomaUniqueID: "",
  candidatePoliceRecordFileFriendlyName: "",
  candidatePoliceRecordUniqueID: "",

  isLoggedIn: false
};

const AuthReducer = (state = AuthInitVal, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        candidateID: action.payload.candidateID,
        personalEmail: action.payload.personalEmail,
        firstName: action.payload.firstName,
        middleName: action.payload.middleName,
        lastName: action.payload.lastName,
        currentTitle: "",
        currentCompany: "",
        primaryPhone: action.payload.primaryPhone ? action.payload.primaryPhone : "",
        secondaryPhone: action.payload.secondaryPhone,
        preferedContactMethodID: action.payload.preferedContactMethodID,
        homeAddress1: action.payload.homeAddress1,
        homeAddress2: action.payload.homeAddress2,
        homeAddress3: action.payload.homeAddress3,
        city: action.payload.city,
        province: "",
        stateID: action.payload.stateID,
        zipCode: action.payload.zipCode ? action.payload.zipCode : "",
        countryID: action.payload.countryID,
        countryName: action.payload.countryName,
        highestLevelOfEducationID: action.payload.highestLevelOfEducationID,

        candidateCoverLetterUniqueID: action.payload.candidateCoverLetterUniqueID,
        candidateResumeUniqueID: action.payload.candidateResumeUniqueID,
        candidateCoverLetterFileFriendlyName: action.payload.candidateCoverLetterFileFriendlyName,
        candidateResumeFileFriendlyName: action.payload.candidateResumeFileFriendlyName,

        candidateBirthCertificateUniqueID: action.payload.candidateBirthCertificateUniqueID,
        candidateBirtCertificateFriendlyName: action.payload.candidateBirtCertificateFriendlyName,
        candidateCXCUniqueID: action.payload.candidateCXCUniqueID,
        candidateCXCFriendlyName: action.payload.candidateCXCFriendlyName,
        candidateCOCUniqueID: action.payload.candidateCOCUniqueID,
        candidateCOCFileFriendlyName: action.payload.candidateCOCFileFriendlyName,

        candidateNationalIDFileFriendlyName: action.payload.candidateNationalIDFileFriendlyName,
        candidateNationalIDUniqueID: action.payload.candidateNationalIDUniqueID,
        candidateHSDiplomaFileFriendlyName: action.payload.candidateHSDiplomaFileFriendlyName,
        candidateHSDiplomaUniqueID: action.payload.candidateHSDiplomaUniqueID,
        candidatePoliceRecordFileFriendlyName: action.payload.candidatePoliceRecordFileFriendlyName,
        candidatePoliceRecordUniqueID: action.payload.candidatePoliceRecordUniqueID,

        isLoggedIn: true,
      };
    case "LOGOUT":
      return AuthInitVal;
    case "UPDATE":
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export default AuthReducer;
